export const locale = {
    lang: 'es',
    data: {
      'MODALES': {
        'ERROR_DATOS':'Ocurrio un error A-721',
        'MODAL_SECC_CONF_VOIC':'Se agregó la sección de configuración de voz para la encuesta, es necesario validar nuevamente los pasos abiertos o completados anteriormente por favor.',
        'VALIDACION':{
          'ERROR1':'Aún tienen preguntas sin traducir',
          'WARNING-SIN-TRADUCCION':'Favor de agregar su traduccion del reactivo',
          'MODAL-GUARDANDO':'Guardando Reactivo'
        },
        'TITULO': 'Ocurrió un error',
        'TITULOS': {
          'error': 'Ocurrió un error',
          'adver': 'Advertencia',
          'aviso': 'Aviso',
          'opSuc': 'Acción completada'
        },
        'ACCIONES': {
          'aceptar' : 'Aceptar',
          'cancelar': 'Cancelar',
          'INFORMATIVO': 'No volver a mostrar mensaje'
        },
        'EXPEDIENTES':{
          'Resultados': 'Aún no se cuenta con los resultados de la encuesta',
          'CARGANDO_COLABORADORES':'Cargando colaboradores que necesitan seguimiento médico',
        },
        'MENSAJES': {
          'NO_FECH_LAN':'Datos incompletos,seleccione la fecha de lanzamiento del producto',
          'NO_RESU_ACTI':'Por el momento los resultados no están disponibles, porfavor intentar más tarde',
          'OK':'OK',
          'Something is wrong': 'Algo está mal',
          'password wrong': 'La contraseña introducida es incorrecta',
          'User does not exist': 'El correo introducido no está registrado en CULTURAL GO®',
          '150': 'Se insertaron los colaboradores',
          'Error: user already exist': 'El usuario que intenta registrar ya existe en CULTURAL GO®',
          'CONEX': {
            'SIN': 'Su equipo ha perdido la conexión a internet\n\nPara continuar utilizando la plataforma, conecte su equipo a internet',
            'CON': 'Su equipo ha recuperado la conexión a internet\n\nAhora puede continuar utilizando la plataforma'
          },
          'WIZARD': {
            'CERTIFICAR' : {
              'RESTRICCIONES': {
                'rest1': 'Para acceder a esta sección es necesario que elija los <b>idiomas</b> para la encuesta',
                'rest2': 'Para acceder a esta sección es necesario que complete todos los pasos anteriores',
                'rest3': 'Para acceder a esta sección es necesario que complete la <b>programación de la encuesta</b>',
                'rest4': 'Para acceder a esta sección es necesario que haya realizado el <b>envío de correos</b> a sus colaboradores y que la encuesta haya sido lanzada',
                'rest5': 'Para acceder a esta sección es necesario que configure los <b>Demográficos</b> para la encuesta'
              },
              'IDIOMAS': {
                'NADA': 'Aún no ha realizado la selección de los idiomas principal y adicionales',
                'NODEFAULT': 'Aún no ha seleccionado el idioma principal',
                'NOADICIONAL': 'Aún no ha seleccionado idiomas adicionales',
                'COMPLETAR': '¿Está seguro de completar el paso con la selección actual de idiomas?',
                '210': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se elige el idioma principal e idiomas adicionales en los que se presentará la encuesta al colaborador',
                'ARCHIVOCOMFIRM':'¡Advertencia! Asegúrate de trabajar el archivo de Excel en un único sistema operativo para evitar conflictos de codificación',
                'BOTONTEXTO':'Enterado',

                'TITULO_DESBLOQUEAR': '<span>¿Está seguro de reabrir el paso de idiomas, tenga en cuenta que esto <font color="red">reiniciará</font> su producto actual y borrará toda la información que haya agregado a las secciones?</span>',
                'BOTON_CONFIRM': 'Sí, reabrir',
                'BOTON_CANCEL': 'Cancelar',
                'SUCCES': 'El paso ha sido reabierto con éxito',
                'BLOQUEADO': 'El paso ya esta abierto',
                'CERRAR': 'Cerrar'
              },
              'TEMPLATE': {
                // 'NADA': 'Aún no ha realizado la selección de los idiomas principal y adicionales',
                // 'NODEFAULT': 'Aún no ha seleccionado el idioma principal',
                // 'NOADICIONAL': 'Aún no ha seleccionado idiomas adicionales',
                // 'COMPLETAR': '¿Está seguro de completar el paso con la selección actual de idiomas?',
                // '210': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se puede realizar las modificaciones en la plantilla',
                // 'ARCHIVOCOMFIRM':'¡Advertencia! Asegúrate de trabajar el archivo de Excel en un único sistema operativo para evitar conflictos de codificación',
                // 'BOTONTEXTO':'Enterado',

                // 'TITULO_DESBLOQUEAR': '<span>¿Está seguro de reabrir el paso de idiomas, tenga en cuenta que esto <font color="red">reiniciará</font> su producto actual y borrará toda la información que haya agregado a las secciones?</span>',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'NPS': {
                'NADA': 'No ha creado ningun NPS o marcado la opción sin NPS',
                'COMPLETAR': '¿Está seguro de completar el paso con sus NPS actuales?',
                '219': 'El paso se completó correctamente',
                '220': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se pueden modificar sus NPS para la encuesta',
                'FALTANTES': 'Aún no ha completado el llenado de sus NPS',
                'FALTANTES_TRADUCCIONES': 'Aún no ha completado el llenado de las traducciones de todas las preguntas',
                'FALTANTES_SECCIONES_ESPECIALES': 'Aún no ha ingresado la clave de la seccion especial',
                'FALTANTES_RESPUESTAS': 'Aún no puede completar el paso, todas las preguntas de múltiple opcion deben tener al menos dos opciones de respuesta',
                'SIN_PREGUNTAS': 'Necesita agregar al menos una pregunta para completar el paso',
                'SIN_GRUPOS': 'Necesita agregar al menos un grupo de preguntas con una pregunta dentro para completar el paso',

                'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de NPS?',
                'BOTON_CONFIRM': 'Sí, reabrir',
                'BOTON_CANCEL': 'Cancelar',
                'SUCCES': 'El paso ha sido reabierto con éxito',
                'BLOQUEADO': 'El paso ya esta abierto',
                'CERRAR': 'Cerrar'
              },
              'REACTIVOS': {
                'NADA': 'No ha creado ningun reactivo o marcado la opción sin reactivos',
                'COMPLETAR': '¿Está seguro de completar el paso con los reactivos introducidos actualmente?',
                '218': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se pueden agregar reactivos a la encuesta',
                'FALTANTES': 'Aun no ha completado el llenado de sus reactivos',
                'FALTANTES_TRADUCCIONES': 'Aún no ha completado el llenado de las traducciones de todas las preguntas',
                'FALTANTES_SECCIONES_ESPECIALES': 'Aún no ha ingresado la clave de la seccion especial',
                'FALTANTES_RESPUESTAS': 'Aún no puede completar el paso, todas las preguntas de múltiple opcion deben tener al menos dos opciones de respuesta',
                'SIN_PREGUNTAS': 'Necesita agregar al menos una pregunta para completar el paso',
                'SIN_GRUPOS': 'Necesita agregar al menos un grupo de preguntas con una pregunta dentro para completar el paso',

                'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de Reactivos?',
                'BOTON_CONFIRM': 'Sí, reabrir',
                'BOTON_CANCEL': 'Cancelar',
                'SUCCES': 'El paso ha sido reabierto con éxito',
                'BLOQUEADO': 'El paso ya esta abierto',
                'CERRAR': 'Cerrar'
              },
              'FORALL': {
                'NADA': 'Aún no ha completado el llenado de prácticas 4ALL',
                'COMPLETAR': '¿Está seguro de completar el paso con las prácticas 4ALL introducidas actualmente?',
                '212': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se enlistan las actividades que se realizan en la empresa, mismas que involucran la participación de todos los colaboradores',
                'NADA_TRA': 'Aún no has completado las traducciones de las prácticas 4ALL',
                'FALTANTES_TRADUCCIONES': 'Aún no ha completado el llenado de las traducciones de todas las preguntas',
                'FALTANTES_SECCIONES_ESPECIALES': 'Aún no ha ingresado la clave de la seccion especial',
                'FALTANTES_RESPUESTAS': 'Aún no puede completar el paso, todas las preguntas de múltiple opcion deben tener al menos dos opciones de respuesta',
                'SIN_PREGUNTAS': 'Necesita agregar al menos una pregunta para completar el paso',
                'SIN_GRUPOS': 'Necesita agregar al menos un grupo de preguntas con una pregunta dentro para completar el paso',

                'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de prácticas 4ALL?',
                'BOTON_CONFIRM': 'Sí, reabrir',
                'BOTON_CANCEL': 'Cancelar',
                'SUCCES': 'El paso ha sido reabierto con éxito',
                'BLOQUEADO': 'El paso ya esta abierto',
                'CERRAR': 'Cerrar'
              },
              'CONTROL': {
                'NADA': 'No ha creado ninguna pregunta de control o marcado la opción sin control',
                'COMPLETAR': '¿Está seguro de completar el paso con su pregunta de control actual?',
                '221': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se puede modificar su pregunta de control para la encuesta',
                'FALTANTES': 'Aún no ha completado el llenado de su pregunta de control',
                'FALTANTES_TRADUCCIONES': 'Aún no ha completado el llenado de las traducciones de todas las preguntas',
                'FALTANTES_SECCIONES_ESPECIALES': 'Aún no ha ingresado la clave de la seccion especial',
                'FALTANTES_RESPUESTAS': 'Aún no puede completar el paso, todas las preguntas de múltiple opcion deben tener al menos dos opciones de respuesta',
                'SIN_PREGUNTAS': 'Necesita agregar al menos una pregunta para completar el paso',
                'SIN_GRUPOS': 'Necesita agregar al menos un grupo de preguntas con una pregunta dentro para completar el paso',

                'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de pregunta de control?',
                'BOTON_CONFIRM': 'Sí, reabrir',
                'BOTON_CANCEL': 'Cancelar',
                'SUCCES': 'El paso ha sido reabierto con éxito',
                'BLOQUEADO': 'El paso ya esta abierto',
                'CERRAR': 'Cerrar'
              },
              'DEMOGRAFICOS': {
                'NADA': 'Aún no ha seleccionado demográficos',
                'COMPLETAR': '¿Está seguro de completar el paso con la información de demográficos introducida actualmente?',
                '213': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se establecen las opciones demográficas que serán puestas a disposición del colaborador en la encuesta',
                'FALTANTES_TRADUCCIONES': 'Aún no ha completado el llenado de las traducciones de todas las preguntas',
                'FALTANTES_SECCIONES_ESPECIALES': 'Aún no ha ingresado la clave de la seccion especial',
                'FALTANTES_RESPUESTAS': 'Aún no puede completar el paso, todas las preguntas de múltiple opcion deben tener al menos dos opciones de respuesta',
                'SIN_PREGUNTAS': 'Necesita agregar al menos una pregunta para completar el paso',
                'SIN_GRUPOS': 'Necesita agregar al menos un grupo de preguntas con una pregunta dentro para completar el paso',

                'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de demográficos?',
                'BOTON_CONFIRM': 'Sí, reabrir',
                'BOTON_CANCEL': 'Cancelar',
                'SUCCES': 'El paso ha sido reabierto con éxito',
                'BLOQUEADO': 'El paso ya esta abierto',
                'CERRAR': 'Cerrar'
              },
              'ABIERTAS': {
                'NADA': 'No ha creado ninguna pregunta abierta o marcado la opción sin preguntas abiertas',
                'COMPLETAR': '¿Está seguro de completar el paso con las preguntas abiertas introducidas actualmente?',
                '220': 'El paso se completó correctamente',
                '219': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se pueden agregar preguntas abiertas a la encuesta',
                'FALTANTES': 'Aún no ha completado el llenado de sus preguntas abiertas',
                'FALTANTES_TRADUCCIONES': 'Aún no ha completado el llenado de las traducciones de todas las preguntas',
                'FALTANTES_SECCIONES_ESPECIALES': 'Aún no ha ingresado la clave de la seccion especial',
                'FALTANTES_RESPUESTAS': 'Aún no puede completar el paso, todas las preguntas de múltiple opcion deben tener al menos dos opciones de respuesta',
                'SIN_PREGUNTAS': 'Necesita agregar al menos una pregunta para completar el paso',
                'SIN_GRUPOS': 'Necesita agregar al menos un grupo de preguntas con una pregunta dentro para completar el paso',

                'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de preguntas abiertas?',
                'BOTON_CONFIRM': 'Sí, reabrir',
                'BOTON_CANCEL': 'Cancelar',
                'SUCCES': 'El paso ha sido reabierto con éxito',
                'BLOQUEADO': 'El paso ya esta abierto',
                'CERRAR': 'Cerrar'
              },
              'ADICIONALES': {
                'NADA': 'No ha creado ninguna pregunta adicional o marcado la opción sin preguntas adicionales',
                'COMPLETAR': '¿Está seguro de completar el paso con las preguntas adicionales introducidas actualmente?',
                '214': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se pueden agregar preguntas personalizadas a la encuesta',
                'FALTANTES_TRADUCCIONES': 'Aún no ha completado el llenado de las traducciones de todas las preguntas',
                'FALTANTES_SECCIONES_ESPECIALES': 'Aún no ha ingresado la clave de la seccion especial',
                'FALTANTES_RESPUESTAS': 'Aún no puede completar el paso, todas las preguntas de múltiple opcion deben tener al menos dos opciones de respuesta',
                'SIN_PREGUNTAS': 'Necesita agregar al menos una pregunta para completar el paso',
                'SIN_GRUPOS': 'Necesita agregar al menos un grupo de preguntas con una pregunta dentro para completar el paso',

                'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de Adicionales?',
                'BOTON_CONFIRM': 'Sí, reabrir',
                'BOTON_CANCEL': 'Cancelar',
                'SUCCES': 'El paso ha sido reabierto con éxito',
                'BLOQUEADO': 'El paso ya esta abierto',
                'CERRAR': 'Cerrar'
              },
              'COLABORADORES': {
                'NADA': 'Aún no ha cargado la información de sus colaboradores a CULTURAL GO®',
                'COMPLETAR': '¿Está seguro de completar el paso con la lista de colaboradores cargada actualmente?',
                '211': 'El paso se completó correctamente',
                '200': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se carga la lista de colaboradores a los que se les enviará la invitación a la encuesta vía correo electrónico',
                'ACTUALIZAR': 'Se agregaron correctamente los colaboradores a la encuesta',

                'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de colaboradores?',
                'BOTON_CONFIRM': 'Sí, reabrir',
                'BOTON_CANCEL': 'Cancelar',
                'SUCCES': 'El paso ha sido reabierto con éxito',
                'BLOQUEADO': 'El paso ya esta abierto',
                'CERRAR': 'Cerrar'
              },
              'PROGRAMACION': {
                'NADA': 'Aún no ha programado fechas',
                'NADA1': 'Aún no ha programado fecha de lanzamiento',
                'NADA2': 'Aún no ha programado fecha de recordatorio',
                'COMPLETAR': '¿Está seguro de completar el paso con las fechas programadas?',
                'GENERAR': '¿Está seguro de completar el paso?',
                '215': 'El paso se completó correctamente',
                '217': 'El paso se completó correctamente', //CERTIFICAR2.0
                'COMPLETADO': 'Ya ha completado este paso',
                'FECHALANZAMIENTO': 'Aún no ha ingresado su fecha de lanzamiento',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se establecen las fechas de lanzamiento y envío de recordatorios para la realización de la encuesta',
                'INFORMATIVO2': 'En esta sección se establecen las fechas de envio de las encuestas Pulse Check',
                'GUARDA-OK':'La fecha se guardó satisfactoriamente',
                'OK':'OK',

                'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de crear encuesta?',
                'TITULO_DESBLOQUEAR2': '¿Está seguro de reabrir el paso de programar encuesta?',
                'BOTON_CONFIRM': 'Sí, reabrir',
                'BOTON_CANCEL': 'Cancelar',
                'SUCCES': 'El paso ha sido reabierto con éxito',
                'BLOQUEADO': 'El paso ya esta abierto',
                'CERRAR': 'Cerrar',
                'NOT_MESS_COM':'Está función no está permitida',
                'DETEC_CAMBIOS_SECCIONES':'Se detectaron cambios en la configuración de las seccion, generar nuevamente la encuesta',


              },
              'ENVIO': {
                'NADA': 'Aún no ha realizado el envío de la invitación a la encuesta a sus colaboradores',
                'NADA_OPCION': 'Aún no ha configurado si el envío de la invitación se hará por correo electrónico',
                'COMPLETAR': '¿Está seguro de completar el paso?',
                '216': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se ejecuta el envío de la invitación para la realización de la encuesta a los colaboradores',

                'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de envío de correos?',
                'BOTON_CONFIRM': 'Sí, reabrir',
                'BOTON_CANCEL': 'Cancelar',
                'SUCCES': 'El paso ha sido reabierto con éxito',
                'BLOQUEADO': 'El paso ya esta abierto',
                'CERRAR': 'Cerrar'
              },
              'CONFIRMACION': {
                // 'NADA': 'Aún no ha realizado el envío de la invitación a la encuesta a sus colaboradores',
                // 'NADA_OPCION': 'Aún no ha configurado si el envío de la invitación se hará por correo electrónico',
                // 'COMPLETAR': '¿Está seguro de completar el paso?',
                // '216': 'El paso se completó correctamente',
                // 'COMPLETADO': 'Ya ha completado este paso',
                // 'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                 'INFORMATIVO': 'En esta sección se puede activar o desactivar la encuesta',
                // 'TITULO_DESBLOQUEAR': '¿Está seguro de reabrir el paso de envío de correos?',
                // 'BOTON_CONFIRM': 'Sí, reabrir',
                // 'BOTON_CANCEL': 'Cancelar',
                // 'SUCCES': 'El paso ha sido reabierto con éxito',
                // 'BLOQUEADO': 'El paso ya esta abierto',
                // 'CERRAR': 'Cerrar'
              },
              'CIERRE': {
                'NADA': 'La encuesta aún no ha concluído',
                'COMPLETAR': '¿Está seguro de completar el paso?',
                '217': 'El paso se completó correctamente',
                'COMPLETADO': 'Ya ha completado este paso',
                'RESTRICCION': 'No es posible realizar esta acción una vez que ya ha completado este paso',
                'INFORMATIVO': 'En esta sección se puede consultar el progreso actual de la encuesta, así como realizar el cierre anticipado de la misma',
                'INFORMATIVO2': 'En esta sección puedes consultar el progreso actual de cada una de las encuestas Pulse Check Lanzadas'
              }
            },
            'NOM35': {
              'CENTROS': {
                'AUTOLOGIN': {
                  'TITULO': 'Advertencia',
                  'INFO': 'Advertencia\n\nSe cerrará su sesión y se procederá a iniciar sesión con el centro de trabajo seleccionado.\n\n¿Confirme iniciar sesión con el centro de trabajo?',
                  'INFOODS': 'Advertencia\n\nSe cerrará su sesión y se procederá a iniciar sesión con la empresa seleccionada.\n\n¿Confirme iniciar sesión con la empresa?'
                }
              }
            },
            'FOCUS':{
              'MODAL-AUNAUTORIZACION':'Aun no cuenta con la autorizacion ',
              'BTN-ENTERADO':'ENTERADO',
              'MODAL-AUTORIZACION':'Se ha enviado tu encuesta a validar',


            },
          }
        },
        'ERRORES': {
          'Ocurrió un error desconocido': 'Su equipo está presentando una falla de conexión con la plataforma, por favor intente acceder nuevamente más tarde',
          '102': 'El correo introducido no está registrado en CULTURAL GO®',
          '103': 'La contraseña introducida es incorrecta',
          '101': 'El correo ya se encuentra registrado, por favor ingrese otro',
          // 'verifyToken_3': '<span>La plataforma ha tenido una actualización recientemente, por este motivo y para evitar pérdida de información, a continuación se cerrará su sesión<br><br>Para asegurar el funcionamiento correcto de la plataforma, antes de acceder nuevamente le pedimos actualizar su navegador con la combinación de teclas <font color="red">CTRL + F5</font></span>',
          // 'tokenActLogin': '<span>La plataforma ha tenido una actualización recientemente, por este motivo y para asegurar el funcionamiento correcto de la plataforma, le pedimos actualizar su navegador con la combinación de teclas <font color="red">CTRL + F5</font>, posteriormente podrá acceder con toda normalidad a la plataforma</span>'
          'verifyToken_3': '<span>La plataforma ha tenido una actualización recientemente, por este motivo y para evitar pérdida de información, a continuación se cerrará su sesión<br><br>Para asegurar el funcionamiento correcto de la plataforma, <font color="red">su navegador se actualizará de forma automática</font></span>',
          'tokenActLogin': '<span>La plataforma ha tenido una actualización recientemente, por este motivo y para asegurar el funcionamiento correcto de la plataforma, <font color="red">su navegador se actualizará de forma automática</font>, posteriormente podrá acceder con toda normalidad a la plataforma</span>',
          'Demo keys out of stock': 'Se han agotado los usuarios demo de la encuesta',
          'Keys Out Of Stock': 'Se han agotado los usuarios demo de la encuesta',
          'Error: Please Recreate Survey':'Se han detectado modificaciones en las preguntas.\n\n Para continuar es necesario volver a crear la encuesta',
          'IT Manager Not Found':'No se envío el correo al responsable de TI\n\n Ingrese el correo y envié manualmente',
          'NO_PROCC_PROD_ASO':'Actualmente no se ha procesado el producto asociado',
          'ERR_PROCC_PROD_ACT':'Error al actualizar usuarios en SQL',
          '300':'El correo introducido no cuenta con los permisos de acceso',
        },
        'ELIMINAR':{
          'MENSAJETEXTO1': '<span>Para confirmar la eliminación de la empresa ',
          'MENSAJETEXTO2': ', ingrese el nombre de la empresa en la caja de texto</span>',
          'SALIR': 'Salir',
          'VALIDAR': 'Confirmar empresa',
          'ERRORNOMBREEMPRESA': 'El nombre de la empresa ingresado, no coincide con el nombre de la empresa que desea eliminar',
          'MENSAJE': '¿Está seguro?\n\nEstá a punto de borrar la empresa ',
          'CANCELAR': 'Cancelar',
          'CONFIRMAR': 'Si, eliminar',
          'SUCCES': 'Empresa eliminada',
          'CERRAR': 'Cerrar'
        },
        'LOG_SENDGRIND':{
          'CARGANDO': 'Cargando datos, por favor espere...',
          'ASUNTO': 'Debes seleccionar un asunto',
          'CONFIRMAR': 'Cerrar'
        },
        'CERTIV3':{
          'Error saving questions':'ERROR NO SE DE QUE ',
        }
      },

    }
};
